export const ProjectConfigOverride = {
  api_url: "https://api.buscakine.cl",
};